import { Component } from '@angular/core';

@Component({
    selector: 'sbi-cot-back-password-recovery-successful',
    templateUrl: './password-recovery-successful.component.html',
    styleUrls: ['./password-recovery-successful.component.scss'],
    standalone: false
})
export class PasswordRecoverySuccessfulComponent {
  constructor() {}
}
